import { render, staticRenderFns } from "./EditClientes.vue?vue&type=template&id=27e5d5f6&scoped=true&"
import script from "./EditClientes.vue?vue&type=script&lang=js&"
export * from "./EditClientes.vue?vue&type=script&lang=js&"
import style0 from "./EditClientes.vue?vue&type=style&index=0&id=27e5d5f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e5d5f6",
  null
  
)

export default component.exports